module.exports = __webpack_public_path__ + "static/media/banner.91f33f00.png";